import api from '@/api/api';

const host = process.env.VUE_APP_CCAPI;
const hostGCAPI = process.env.VUE_APP_GSAPI;
const key = process.env.VUE_APP_GSAPI_KEY;

export default class WsQuotation {

    getToken = async() => {
        const resource = `/token/generate`;
        const API_URL = `${hostGCAPI}${resource}`;
        const config = {
            headers: {
                "Content-Type": "application/json",
            }
        };

        const params = {
            apikey: key
        };

        return await api.httpGet(API_URL, config , params);
    }

    post = async(token, params) => {
        const resource = `/vs/quote`;
        const API_URL = `${hostGCAPI}${resource}`;

        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Token ${token}`
            }
        };

        return await api.httpPost(API_URL, config, params);
    }

    getUserInformation = async (token, userId) => {

        const resource = `/${process.env.VUE_APP_BUSINESS_FONCABSA}/persons/vs_info_to_quote`;
        const API_URL = `${host}${resource}`;
        const config = {
            headers: {
                "Content-Type": "application/json",
            }
        };

        const params = {
            token_auth: token,
            user_id: userId
        };

        return await api.httpGet(API_URL, config , params);
    }
}